import {
  CallRecordIcon,
  HomeIcon,
  LeadsIcon,
  TasksIcon,
  TokenIcon,
  AdminIcon,
  PropertyUnitIcon,
  PieChartIcon,
  StaffTargetIcon,
  CommentIcon,
  TeamIcon,
  ImportIcon,
  ExportIcon,
  ActivityIcon,
  SaleIcon,
} from "assets/svgs";
import { leadTypes } from "utils/constants";

const { rawLead, polishedLead } = leadTypes;

export const leadTypeObj: any = {
  [rawLead]: "leads",
  [polishedLead]: "polished-leads",
};

export const token: string = "token";
export const property: string = "property";
export const projectProperties: string = "project-properties";
export const individualProperties: string = "individual-properties";
export const staffTarget: string = "staff-target";
export const tasks: string = "tasks";
export const project: string = "project";
export const teams: string = "teams";
export const chatApp: string = "chat-apps";

export const activityKey: string = "all-activities";
export const importKey: string = "import";
export const importLeads: string = "import-leads";
export const importProperty: string = "import-property";
export const importIndividualProperty: string = "import-individual-property";
export const bulkOperation: string = "bulk-operation";
export const allLeadsBulk: string = "all-leads-bulk";
export const rawLeadsBulk: string = "raw-leads-bulk";
export const polishLeadsBulk: string = "polish-leads-bulk";

export const whatsapp: string = "whatsapp";

export const pathnameObj: any = {
  leadDetail: "leads/complete-detail",
  tokenDetail: "token/complete-detail",
  propertyDetail: "property/complete-detail",
  staffTargetDetail: "add-target/complete-detail",
  taskDetail: "tasks/complete-detail",
  projectDetail: "project/complete-detail",
  teamDetail: "teams/team-detail",
  userDetail: "teams/user-detail",
};

export const menuItems: any = [
  {
    key: "dashboard",
    backend_key: "dashboard",
    label: "Dashboard",
    icon: HomeIcon,
    path: "/",
    isSubmenu: false,
    show: true,
  },
  {
    key: "leads",
    backend_key: "raw_leads",
    label: "Raw Leads",
    icon: LeadsIcon,
    isSubmenu: true,
    show: true,
    submenu: [
      {
        key: "all-leads",
        label: "All Leads",
        path: "/leads",
        isSubmenu: false,
      },
      {
        key: "all-shared-leads",
        label: "All Shared Leads",
        path: "/leads/shared-leads",
        isSubmenu: false,
      },

      // {
      //   key: "by-status",
      //   label: "By Status",
      //   isSubmenu: true,
      //   submenu: [
      //     {
      //       key: "new",
      //       label: "New",
      //       path: "/leads/status/new",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "active",
      //       label: "Active",
      //       path: "/leads/status/active",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "open",
      //       label: "Open",
      //       path: "/leads/status/open",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "deal-closed-won",
      //       label: "Deal Closed Won",
      //       path: "/leads/status/deal-closed-won",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "deal-closed-lost",
      //       label: "Deal Closed Lost",
      //       path: "/leads/status/deal-closed-lost",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "recycled",
      //       label: "Recycled",
      //       path: "/leads/status/recycled",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "dead",
      //       label: "Dead",
      //       path: "/leads/status/dead",
      //       isSubmenu: false,
      //     },
      //   ],
      // },
      // {
      //   key: "by-priority",
      //   label: "By Priority",
      //   isSubmenu: true,
      //   submenu: [
      //     {
      //       key: "high",
      //       label: "High",
      //       path: "/leads/priority/high",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "normal",
      //       label: "Normal",
      //       path: "/leads/priority/normal",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "low",
      //       label: "Low",
      //       path: "/leads/priority/low",
      //       isSubmenu: false,
      //     },
      //     {
      //       key: "urgent",
      //       label: "Urgent",
      //       path: "/leads/priority/urgent",
      //       isSubmenu: false,
      //     },
      //   ],
      // },
      {
        key: "source",
        label: "Source",
        path: "/source",
        isSubmenu: false,
      },
    ],
  },
  {
    key: "polished-leads",
    backend_key: "polished_leads",
    label: "Polished Leads",
    icon: LeadsIcon,
    isSubmenu: true,
    show: true,
    submenu: [
      {
        key: "all-leads",
        label: "All Leads",
        path: "/polished-leads",
        isSubmenu: false,
      },
      {
        key: "all-shared-leads",
        label: "All Shared Leads",
        path: "/polished-leads/shared-leads",
        isSubmenu: false,
      },
      {
        key: "by-status",
        label: "By Status",
        isSubmenu: true,
        submenu: [
          // {
          //   key: "new",
          //   label: "New",
          //   path: "/polished-leads/status/new",
          //   isSubmenu: false,
          // },
          {
            key: "active",
            label: "Active",
            path: "/polished-leads/status/active",
            isSubmenu: false,
          },
          {
            key: "pending",
            label: "Pending",
            path: "/polished-leads/status/pending",
            isSubmenu: false,
          },
          {
            key: "deal-closed-won",
            label: "Deal Closed Won",
            path: "/polished-leads/status/deal-closed-won",
            isSubmenu: false,
          },
          {
            key: "deal-closed-lost",
            label: "Deal Closed Lost",
            path: "/polished-leads/status/deal-closed-lost",
            isSubmenu: false,
          },
          {
            key: "recycled",
            label: "Recycled",
            path: "/polished-leads/status/recycled",
            isSubmenu: false,
          },
          {
            key: "dead",
            label: "Dead",
            path: "/polished-leads/status/dead",
            isSubmenu: false,
          },
        ],
      },
      {
        key: "by-priority",
        label: "By Priority",
        isSubmenu: true,
        submenu: [
          {
            key: "high",
            label: "High",
            path: "/polished-leads/priority/high",
            isSubmenu: false,
          },
          {
            key: "normal",
            label: "Normal",
            path: "/polished-leads/priority/normal",
            isSubmenu: false,
          },
          {
            key: "low",
            label: "Low",
            path: "/polished-leads/priority/low",
            isSubmenu: false,
          },
          {
            key: "urgent",
            label: "Urgent",
            path: "/polished-leads/priority/urgent",
            isSubmenu: false,
          },
        ],
      },
      {
        key: "lead-request",
        label: "Shared Lead Request",
        path: "/lead-request",
        isSubmenu: false,
      },
    ],
  },
  {
    key: "tasks",
    backend_key: "tasks",
    label: "Tasks",
    icon: TasksIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "all-tasks",
        label: "All Tasks",
        path: "/tasks",
        isSubmenu: false,
      },
      {
        key: "by-status",
        label: "By Status",
        isSubmenu: true,
        submenu: [
          {
            key: "open",
            label: "Open",
            path: "/tasks/status/open",
            isSubmenu: false,
          },
          {
            key: "closed",
            label: "Closed",
            path: "/tasks/status/closed",
            isSubmenu: false,
          },
          {
            key: "pending",
            label: "Pending",
            path: "/tasks/status/pending",
            isSubmenu: false,
          },
        ],
      },
      {
        key: "by-priority",
        label: "By Priority",
        isSubmenu: true,
        submenu: [
          {
            key: "high",
            label: "High",
            path: "/tasks/priority/high",
            isSubmenu: false,
          },
          {
            key: "normal",
            label: "Normal",
            path: "/tasks/priority/normal",
            isSubmenu: false,
          },
          {
            key: "low",
            label: "Low",
            path: "/tasks/priority/low",
            isSubmenu: false,
          },
          {
            key: "urgent",
            label: "Urgent",
            path: "/tasks/priority/urgent",
            isSubmenu: false,
          },
        ],
      },
    ],
  },
  {
    key: "token",
    backend_key: "tokens",
    label: "Token",
    icon: TokenIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "all-token",
        label: "All Token",
        path: "/token",
        isSubmenu: false,
      },
      {
        key: "by-status",
        label: "By Status",
        isSubmenu: true,
        submenu: [
          {
            key: "open",
            label: "Active Tokens",
            path: "/token/status/open",
            isSubmenu: false,
          },
          {
            key: "deal-won",
            label: "Deal Closed Tokens",
            path: "/token/status/deal-won",
            isSubmenu: false,
          },
          {
            key: "deal-lost",
            label: "Deal Lost Tokens",
            path: "/token/status/deal-lost",
            isSubmenu: false,
          },
          {
            key: "time-expired",
            label: "Expired Tokens",
            path: "/token/status/time-expired",
            isSubmenu: false,
          },
          {
            key: "time-extended",
            label: "Extended Tokens",
            path: "/token/status/time-extended",
            isSubmenu: false,
          },
        ],
      },
    ],
  },

  {
    key: "sales",
    backend_key: "sales",
    label: "Sales",
    icon: SaleIcon,
    path: "/sales",
    isSubmenu: false,
    show: true,
  },

  {
    key: "project-properties",
    backend_key: "project_inventory",
    label: "Project Inventory",
    icon: PropertyUnitIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "project",
        label: "All Projects",
        path: "/project",
        isSubmenu: false,
      },
      {
        key: "all-properties",
        label: "All Properties",
        path: "/project-properties",
        isSubmenu: false,
      },
      {
        key: "project-property-by-status",
        label: "By Status",
        isSubmenu: true,
        submenu: [
          {
            key: "available",
            label: "Available",
            path: "/project-properties/status/available",
            isSubmenu: false,
          },
          {
            key: "booked",
            label: "Booked",
            path: "/project-properties/status/booked",
            isSubmenu: false,
          },
          {
            key: "sold",
            label: "Sold",
            path: "/project-properties/status/sold",
            isSubmenu: false,
          },
          {
            key: "not-available",
            label: "Not Available",
            path: "/project-properties/status/not-available",
            isSubmenu: false,
          },
        ],
      },
    ],
  },
  {
    key: "individual-properties",
    backend_key: "non_project_inventory",
    label: "Non-Project Inventory",
    icon: PropertyUnitIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "all-properties",
        label: "All Properties",
        path: "/individual-properties",
        isSubmenu: false,
      },
      {
        key: "individual-property-by-status",
        label: "By Status",
        isSubmenu: true,
        submenu: [
          {
            key: "available",
            label: "Available",
            path: "/individual-properties/status/available",
            isSubmenu: false,
          },
          {
            key: "booked",
            label: "Booked",
            path: "/individual-properties/status/booked",
            isSubmenu: false,
          },
          {
            key: "sold",
            label: "Sold",
            path: "/individual-properties/status/sold",
            isSubmenu: false,
          },
          {
            key: "not-available",
            label: "Not Available",
            path: "/individual-properties/status/not-available",
            isSubmenu: false,
          },
        ],
      },
    ],
  },
  {
    key: "call-record",
    backend_key: "call_records",
    label: "Call Records",
    icon: CallRecordIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "all-calls",
        label: "All Calls",
        path: "/call-record",
        isSubmenu: false,
      },
    ],
  },
  {
    key: "staff-target",
    backend_key: "staff_targets",
    label: "Staff Targets",
    icon: StaffTargetIcon,
    // path: "/add-target",
    isSubmenu: true,
    show: true,
    submenu: [
      {
        key: "all-target",
        label: "All Target",
        path: "/add-target",
        isSubmenu: false,
      },
      {
        key: "target-by-status",
        label: "By Status",
        isSubmenu: true,
        submenu: [
          {
            key: "not-started",
            label: "Not Started",
            path: "/add-target/status/not-started",
            isSubmenu: false,
          },
          {
            key: "in-progress",
            label: "In Progress",
            path: "/add-target/status/in-progress",
            isSubmenu: false,
          },
          {
            key: "stopped",
            label: "Stopped",
            path: "/add-target/status/stopped",
            isSubmenu: false,
          },
          {
            key: "completed",
            label: "Completed",
            path: "/add-target/status/completed",
            isSubmenu: false,
          },
        ],
      },
    ],
  },
  // {
  //   key: "analysis-and-reports",
  //   backend_key: "analysis_and_reports",
  //   label: "Analysis & Reports",
  //   icon: PieChartIcon,
  //   path: "/analysis-and-reports",
  //   isSubmenu: false,
  //   show: true,
  // },
  {
    key: "all-activities",
    backend_key: "activity_logs",
    label: "Activity Logs",
    icon: ActivityIcon,
    path: "/all-activities",
    isSubmenu: false,
    show: true,
  },
  // {
  //   key: "leads-kanban-view",
  //   backend_key: "leads_kanban_view",
  //   label: "Leads Kanban View",
  //   icon: LeadsIcon,
  //   path: "/leads-kanban-view",
  //   isSubmenu: false,
  //   show: true,
  // },

  {
    key: "chat-apps",
    backend_key: "social_media",
    label: "Social Media",
    icon: CommentIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "messenger",
        label: "Messenger",
        path: "/chat-app/messenger",
        isSubmenu: false,
      },
      {
        key: "whatsapp",
        label: "Whatsapp",
        path: "/chat-app/Home",
        isSubmenu: false,
      },
    ],
  },
  {
    key: "teams",
    backend_key: "user_management",
    label: "User Management",
    icon: TeamIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "users",
        label: "Users",
        path: "/teams/users",
        isSubmenu: false,
      },
      {
        key: "team",
        label: "Team",
        path: "/teams/team",
        isSubmenu: false,
      },
    ],
  },
  {
    key: "import",
    backend_key: "import_data",
    label: "Import Data",
    icon: ImportIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "import-leads",
        label: "Leads",
        path: "/import/lead",
        isSubmenu: false,
      },
      {
        key: "import-property",
        label: "Project Inventory",
        path: "/import/project-property",
        isSubmenu: false,
      },
      {
        key: "import-individual-property",
        label: "Non-Project Inventory",
        path: "/import/individual-property",
        isSubmenu: false,
      },
    ],
  },

  {
    key: "bulk-operation",
    backend_key: "bulk_actions",
    label: "Bulk Actions",
    icon: ExportIcon,
    show: true,
    isSubmenu: true,
    submenu: [
      {
        key: "all-leads-bulk",
        label: "All Leads",
        path: "/bulk-operation/all-lead",
        isSubmenu: false,
      },
      {
        key: "raw-leads-bulk",
        label: "Raw Leads",
        path: "/bulk-operation/raw-lead",
        isSubmenu: false,
      },
      {
        key: "polish-leads-bulk",
        label: "Polish Leads",
        path: "/bulk-operation/polished-lead",
        isSubmenu: false,
      },
      {
        key: "pending-leads-bulk",
        label: "Pending Leads",
        path: "/bulk-operation/pending-lead",
        isSubmenu: false,
      },
    ],
  },
];

export const sidebarSubMenuObj: any = {
  mainMenu: [
    "leads",
    "polished-leads",
    "tasks",
    "token",
    "property",
    "call-record",
    "staff-target",
    "chat-apps",
    "teams",
    "project-properties",
    "individual-properties",
    "import",
    "bulk-operation",
  ],
  subMenu: ["by-status", "by-priority", "target-by-status"],
};

export const adminOperations = "admin-operations";

export const withoutSubmenuItems: string[] = [
  "/",
  "/analysis-and-reports",
  "/all-activities",
  "/sales",
  "/leads-kanban-view",
];

export const themeObject: { [key: string]: string } = {
  dark: "dark_theme",
  light: "light_theme",
};

export const keysToHideFromUser: string[] = ["lead-request"];
